<div class="contact-page-area pd-top-110">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-lg-6">
        <div class="text-center">
          <a [routerLink]="['/']"><img src="/assets/img/logo.png" style="margin-bottom: 100px;" /></a>
          <h2 class="text-center">Login</h2>
          <div class="log-in-form">
            <div class="tab-content">
              <div class="tab-pane fade show active" id="pills-home">
                <form [formGroup]="loginForm" (ngSubmit)="onSubmitLogin(loginForm.value)" _lpchecked="1">                 
                  <div *ngIf="invalidLogin"><p>
                    *Email and/or password is not recognized
                  </p></div>
                  <div class="form-group">
                    <label>Email address*</label>
                    <input type="text" id="email" type="email" class="form-control" formControlName="email"
                      placeholder="youremail@gmail.com" autocomplete="off"
                      style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
                  </div>
                  <div class="form-group">
                    <label>Password</label>
                    <input formControlName="password" id="password" type="password" placeholder="password"
                      class="form-control" autocomplete="off"
                      style="background-image: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC&quot;); background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
                  </div>
                  <button type="submit" class="btn btn-base w-100">Login</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>